import Button from 'ui/atoms/button';
import styled from 'styled-components';

export const EditQuestionsButton = styled(Button)`
  padding-top: 0;
  padding-bottom: 8px;
`;
